import styled from 'styled-components';
import { textLarge } from '../../../styles/texts';

const ContentItemData = styled.p`
  ${textLarge};
  color: ${({ theme }) => theme.color.text.primary.dark};
`;

export { ContentItemData };